import { createSelector } from "reselect";
import { populationIncidenceChartDataSelector } from "../population_incidence_chart_data_selector";

export const populationIncidenceChartDataDataSelector = createSelector(
  populationIncidenceChartDataSelector,
  chartData => {
    return chartData.data;
  }
);
